import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';

import { makeStyles } from '@material-ui/core/styles';
import { Button } from '@material-ui/core';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';

import { logout, setUser } from 'modules/auth';
import { getMenu } from 'modules/menu';
import { login } from 'lib/api/auth';
import { showSuccessSnackbar } from 'modules/snackbar';

import LoginForm from 'pages/Login/LoginForm/LoginForm';

import {
  externalCode,
  getMembersFilter,
  setProductCode,
} from '../../../modules/common';
import { productCode } from '../../../lib/api/common';

const useStyles = makeStyles((theme) => ({
  modalTitleContent: { marginBottom: 20 },
  modalConfirmButton: { width: 200, color: '#fff' },
}));

let userData;
const LoginFormContainer = ({ history }) => {
  const classes = useStyles();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const localStorageId = localStorage.getItem('saveId');
  const [form, setForm] = useState({
    userId: localStorageId === null ? '' : localStorageId,
    password: '',
  });
  const [error, setError] = useState(null);
  const [errorMessage, setErrorMessage] = useState('');
  const [saveId, setSaveId] = useState(localStorageId === null ? false : true);
  const [modalState, setModalState] = useState(false);
  const { user } = useSelector(({ auth }) => ({ user: auth.user }));
  userData = user;

  useEffect(() => {
    localStorage.removeItem('user'); // localStorage 에서 user 제거
    localStorage.removeItem('adminToken'); // localStorage 에서 user 제거
    if (userData !== null) dispatch(logout());
  }, [dispatch]);

  const handleModalClose = () => {
    setModalState(false);
    setErrorMessage('');
  };

  /**
   * id, pwd 변경 이벤트
   * @param {string} name userId || Password
   */
  const onChange = (name) => (event) => {
    setForm({ ...form, [name]: event.target.value });
  };

  /**
   * 아이디 저장 여부
   * @param {} event
   */
  const onChangeSaveId = (event) => {
    setSaveId(event.target.checked);
  };

  // 폼 등록 이벤트 핸들러
  const onSubmit = (e) => {
    e.preventDefault();
    const { userId, password } = form;
    let errorMesage = '';
    if (userId === '') {
      errorMesage = 'ID를 입력하세요';
    } else if (password === '') {
      errorMesage = 'Password를 입력하세요';
    }

    if (errorMesage !== '') {
      setError(errorMesage);
      return false;
    } else {
      login({ userId, password })
        .then((response) => {
          const { data: user, success } = response.data;
          if (success) {
            try {
              localStorage.setItem('user', JSON.stringify(user));
              localStorage.setItem('adminToken', user.token);
              if (saveId) {
                localStorage.setItem('saveId', user.userid);
              } else {
                localStorage.removeItem('saveId');
              }
            } catch (e) {
              handleClickSnackbar({
                message: 'localStorage is not working',
                option: { type: 'error' },
              });
            }
            if (user) {
              dispatch(setUser(user));
              dispatch(getMenu());
              dispatch(externalCode());
              dispatch(getMembersFilter());
              productCode()
                .then((prdResponse) => {
                  const { platMenus, prdtMenus } = prdResponse.data.data;
                  const platformCodeList = platMenus.map((platFormCode) => {
                    const { CODE_ID, CODE_VAL } = platFormCode;
                    return { label: i18next.t(CODE_VAL), value: CODE_ID };
                  });
                  // 공통으로 쓰이는 상품 구분 코드
                  const productCodeList = new Map();
                  const tempValueObj = {};
                  const allProductCodeList = new Map();
                  for (let code in prdtMenus) {
                    if (prdtMenus.hasOwnProperty(code)) {
                      const curPrdt = prdtMenus[code];
                      const {
                        advrtsPrdtCode: value,
                        advrtsPrdtName: label,
                        item,
                      } = curPrdt;
                      const newItem = item.map((curData) => {
                        const { ADVRTS_TP_CODE: value, ADVRTS_TP_NM: label } =
                          curData;
                        const cur = { label, value };
                        if (typeof tempValueObj[value] === 'undefined') {
                          tempValueObj[value] = 1;
                          allProductCodeList.set(value, cur);
                        }
                        return cur;
                      });
                      productCodeList.set(value, {
                        label,
                        value,
                        item: newItem,
                      });
                    }
                  }
                  dispatch(
                    setProductCode({
                      platformCodeList,
                      productCodeList,
                      allProductCodeList,
                    })
                  );
                })
                .catch((error) => {
                  setError(error.message);
                });
            }
            /** 사용자관리 필터, 외부연동 데이터 가져오는 타이밍이 이쪽이 아닌데 일단 새로고침형태로 남겨둠 */
            history.push('/');
          } else {
            setModalState(true);
          }
        })
        .catch((error) => {
          setErrorMessage(error);
          setError(error);
          setModalState(true);
        });
    }
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <LoginForm
        form={form}
        error={error}
        saveId={saveId}
        onChange={onChange}
        onChangeCheckbox={onChangeSaveId}
        onSubmit={onSubmit}
      />

      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={`${classes.modal} globalModal`}
        open={modalState}
        onClose={handleModalClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{ timeout: 500 }}
      >
        <Fade in={modalState}>
          <div className={`${classes.paper} paper`}>
            <p className={classes.modalTitleContent}>{errorMessage}</p>
            <Button
              variant="contained"
              color="primary"
              className={classes.modalConfirmButton}
              onClick={handleModalClose}
            >
              {t('확인')}
            </Button>
          </div>
        </Fade>
      </Modal>
    </>
  );
};

export default withRouter(LoginFormContainer);
